import styled from 'styled-components';

export const Info = styled.div`
  padding: 1.5rem;
`;

export const RadioInputContainer = styled.div`
  & button > div {
    padding-right: 0;
  }
`;
